
import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    addPartGroup, deletePartGroup, editPartGroup, getAdminReport,
    getAdminReportDownload, getPartGroups, getPartGroupsSearchResults,
} from '../../repositories';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import { ConfirmationModal } from '../../../shared/components/modals/confirmation-modal';
import PGMAside from './aside';
import PartGroupPanel from '../part-group-panel';
import PartGroupSearchPanel from './part-group-result-panel';
import PropTypes from 'prop-types';
import SearchBarWidget from '../../../shared/components/search-bar-widget';
import { connect } from 'react-redux';
import { getProductSeries } from '../../../app/common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
// import MultipleEntryPopup from './multiple-entry-popup';
//import CSVFile from '../../../assets/part_group.csv';
import PartGroupMultipleEntryPopup from './part-group-multiple-entry-popup';
import { downloadSampleReports } from '../../../claims/repositories';

export class PartGroupMaintenance extends Component {

    state = {
        isSearch: false,
        isEdit: false,
        productSeries: [],
        partGroups: [],
        selectedPartGroup: [],
        selectedProductSeries: {},
        confirmMessage: '',
        confirmTitle: '',
        confirmIsOpen: false,
        addNew: false,
        factoryDescription: '',
        searchPlaceHolder: 'Search Part Group',
        newPartNumText: '',
        newPartDescext: '',
        isOpen: false,
        searchedText: '',
        modelIsOpen: false,
        modelIsClose: false,
    };


    componentWillMount = () => {

        this.loadDefault();

    };

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'partGroup' ) {

            this.loadDefault();
            nextProps.updateReload();

        }

    }


    componentDidUpdate = prevProps => {

        if ( prevProps.factoryCode !== this.props.factoryCode ) {

            this.loadDefault();

        }

    };

    loadDefault = () => {

        if ( this.props.factoryCode ) {

            this.props.increaseCounter();
            getProductSeries( this.props.factoryCode ).then( response => {

                this.setState( {
                    productSeries: response,
                    selectedProductSeries: {},
                    isEdit: false,
                    isSearch: false,
                    addNew: false,
                    searchedText: '',
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );
            this.props.factories.forEach( product => {

                if ( product.factoryCode === this.props.factoryCode ) {

                    const { factoryDescription } = product;
                    this.setState( {
                        factoryDescription,
                    } );

                }

            } );

        }

    };

    handleProductSeriesSelect = obj => {

        this.props.increaseCounter();
        getPartGroups( this.props.factoryCode, obj ).then( response => {
                this.setState( {
                partGroups: response,
                selectedProductSeries: obj,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };


    handleSearchChange = searchText => {

        this.setState( {
            searchedText: searchText,
        } );

        if ( searchText.length >= 3 ) {

            const fc = this.props.factoryCode;
            const increaseCntr = () => {

                this.props.increaseCounter();

            };
            const decreaseCntr = () => {

                this.props.decreaseCounter();

            };

            const newStateResponse = ( searchedText, response ) => {
                if ( this.state.isSearch === true
                && searchedText.toUpperCase() === this.state.searchedText.toUpperCase() ) {

                    this.setState( {
                        partGroups: response,
                        isSearch: true,
                        selectedProductSeries: searchedText,
                        confirmIsOpen: false,
                    } );

                }

            };


            clearTimeout( this.delayTimer );
            this.delayTimer = setTimeout( () => {

                increaseCntr();
                this.setState( {
                    isSearch: true,
                    searchedText: searchText,

                }, () => {


                    getPartGroupsSearchResults( fc, searchText.toUpperCase() ).then( response => {

                        newStateResponse( searchText, response );
                        decreaseCntr();

                    } ).catch( ( ) => {

                        decreaseCntr();

                    } );

                } );

            }, 500 );


        } else if ( searchText.length === 0 ) {

            clearTimeout( this.delayTimer );
            this.loadDefault();

        }

    }

    handleGoToPrev = () => {

        this.loadDefault();

    };

    handleRowClick = obj => {
        const selObj = {
            correctedPartDesc: obj.correctedPartDesc,
            factoryCode: obj.factoryCode,
            partGroupDescription: obj.partGroupDescription,
            partGroupId: obj.partGroupId,
            partGroupName: obj.partGroupName,
            partNumber: obj.partNumber,
            partNumberDescription: obj.partNumberDescription,
            productSeriesId: obj.productSeriesId,
            productSeriesName: obj.productSeriesName,
        };
        this.setState( {
            selectedPartGroup: selObj,
            isEdit: true,
            addNew: false,
            isOpen: false,
            newPartNumText: '',
            newPartDescext: '',

        } );

    };

    handleDelete = () => {

        this.setState( {
            confirmMessage: 'Are you sure you want to Delete?',
            confirmIsOpen: true,
            confirmTitle: 'Confirm Delete?',
        } );

    }

    handleConfirmClose = () => {

        this.setState( {
            confirmIsOpen: false,
        } );

    };

    onUploadReport = () => {

        this.setState( {
            modelIsOpen: true,
        } );

    }

    onUploadReportClose = () => {

        this.setState( {
            modelIsOpen: false,
        } );

    };

    handleConfirm = () => {

        this.props.increaseCounter();
        deletePartGroup( this.state.selectedPartGroup ).then( () => {

            this.setState( {
                confirmIsOpen: false,
            } );
            this.props.increaseCounter();
            if ( this.state.isSearch ) {

                this.handleSearchChange( this.state.searchedText );
                this.setState( {
                    isEdit: false,
                } );
                this.props.createSuccessMessage( 'Delete Part Group Successful' );
                this.props.decreaseCounter();

            } else {

                getPartGroups( this.props.factoryCode,
                    this.state.selectedProductSeries ).then( response => {

                    this.setState( {
                        partGroups: response,
                        isEdit: false,
                    } );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Delete Part Group Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };

    handleAsideTextChange = event => {

        const curObj = this.state.selectedPartGroup;
        if ( event.target ) {
            curObj[event.target.name] = event.target.value;
        } else {
            curObj.productSeriesId = event;
        }
        this.state.productSeries.forEach( product => {
        
                if ( product.productSeriesId === curObj.productSeriesId ) {

                    curObj.productSeriesName = product.productSeriesName;

                }

            } );
        this.setState( {
            selectedPartGroup: curObj,
        } );
    }

    handleAsideUpdate = () => {

        this.props.increaseCounter();
        editPartGroup( this.state.selectedPartGroup ).then( () => {

            this.props.increaseCounter();
            getPartGroups( this.props.factoryCode,
                this.state.selectedProductSeries ).then( response => {

                this.setState( {
                    partGroups: response,
                    isEdit: false,
                } );
                this.props.decreaseCounter();
                this.props.createSuccessMessage( 'Update Part Group Successful' );

            } ).catch( () => {

                this.props.decreaseCounter();

            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleAddNew = () => {

        this.setState( {
            addNew: true,
            isEdit: true,
            selectedPartGroup: {},
        } );

    }

    handleCancel = () => {

        this.setState( {
            addNew: false,
            isEdit: false,
        } );

    }

    handleAddNewConfirm = () => {

        this.props.increaseCounter();
        const selPartGroup = this.state.selectedPartGroup;
        // selPartGroup.partGroupId =
        // `${this.props.factoryCode}_${selPartGroup.productSeriesId}_
        // ${selPartGroup.partGroupName}_${selPartGroup.partNumber}`;
        // console.log("selectedProductSeries.productSeriesName",this.state.selectedProductSeries);
       // selPartGroup.productSeriesName = this.state.selectedProductSeries.productSeriesName;
        console.log("selpart",selPartGroup);
        console.log(this.state.selectedProductSeries.productSeriesName);
        addPartGroup( this.props.factoryCode, selPartGroup ).then( () => {
            console.log("inside add new");

            this.loadDefault();
            this.props.decreaseCounter();
            this.props.createSuccessMessage( 'Add New Part Group Successful' );

        } ).catch( (e) => {
            this.props.decreaseCounter()
            console.log("Exception",e.message)

        } );

    }

    handleOpenAddNewSection = () => {

        this.setState( {
            isOpen: true,
        } );

    }

    handleCloseAddNewSection = () => {

        this.setState( {
            isOpen: false,
            newPartNumText: '',
            newPartDescext: '',
        } );

    }

    changeTextNewPartNum =event => {

        this.setState( {
            [event.target.name]: event.target.value,
        } );

    }

    handleaddNewPartNumToGroup = () => {

        const obj = { ...this.state.selectedPartGroup };
        obj.partNumber = this.state.newPartNumText;
        obj.partNumberDescription = this.state.newPartDescext;
        this.props.increaseCounter();
        addPartGroup( this.props.factoryCode, obj ).then( () => {
            this.props.increaseCounter();
            getPartGroups( this.props.factoryCode,
                this.state.selectedProductSeries ).then( response => {

                this.setState( {
                    partGroups: response,
                    isEdit: false,
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

            this.props.decreaseCounter();
            this.props.createSuccessMessage( ' Add New Part Number To Part Group Successful' );

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    downLoadReport = () => {

        this.props.increaseCounter();
        const productSeriesId = Object.keys( this.state.selectedProductSeries ).length !== 0 ? this.state.selectedProductSeries.productSeriesId : '';

        getAdminReport( 'partGrp', this.props.factoryCode, productSeriesId )
            .then( response => {

                getAdminReportDownload( response, 'part_group.csv' );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }
handleDownloadClick = (fileName) => () => {
            console.log("fileName", fileName);
            
            this.props.increaseCounter();
    
            downloadSampleReports(fileName)
                .then(response => {
                    response.blob().then( blob => {
    
                        const url = window.URL.createObjectURL( blob );
                        const a = document.createElement( 'a' );
                        a.setAttribute( 'download', fileName+'.csv' );
                        a.href = url;
                        document.body.appendChild( a );
                        a.click();
                        a.parentNode.removeChild( a );
                
                    } );
                    this.props.decreaseCounter();
                })
                .catch(() => {
                    this.props.decreaseCounter();
                });
        }

    render () {
        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Part Group Maintenance
                        <button className="report-button" type="button" onClick={this.downLoadReport} disabled={Object.keys( this.state.selectedProductSeries ).length === 0}>Download Report</button>
                        {!this.state.isAdd &&
                        <button className="report-button" type="button" onClick={this.onUploadReport}>Upload Report</button> }
                        {/* <a title="Field having values can update only" href={CSVFile} className="upload-report-label" download="part_group.csv">Download Sample Report</a> */}
                        <a
                        className="upload-report-label"
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('part_group')}
                        >
                        Download Sample Report
                    </a>
                    
                    </h2>
                </header>
                <div className="section-with-aside part-group-maintenance">
                    <main>
                        <SearchBarWidget
                            searchPlaceHolder={this.state.searchPlaceHolder}
                            onSearchTextChange={this.handleSearchChange}
                            searchText={this.state.searchedText}
                        />
                        {!this.state.isSearch &&
                            Object.keys( this.state.selectedProductSeries ).length === 0 && (
                            <PartGroupPanel
                                isSearch={this.state.isSearch}
                                handleProductSeriesSelect={this.handleProductSeriesSelect}
                                productList={this.state.productSeries}
                            />
                        )}
                        {Object.keys( this.state.selectedProductSeries ).length !== 0 && (
                            <PartGroupSearchPanel
                                partGropuList={this.state.partGroups}
                                gotoPrev={this.handleGoToPrev}
                                rowClick={this.handleRowClick}
                                mode={this.state.isSearch}
                                selectedPartGroup={this.state.selectedPartGroup}
                                isSearch={this.state.isSearch}
                                selectedProductSeries={this.state.selectedProductSeries}
                            />
                        )}
                    </main>
                    <aside>
                        {!this.state.isEdit && (
                            <div className="addnew-section">
                                <p>Select Part Group to Edit</p>
                                <p>Or</p>
                                <button className="primary-button" type="button" onClick={this.handleAddNew}>Add New Part Group</button>
                            </div>
                        )}
                        {this.state.isEdit && (
                            <PGMAside
                                selectedPartGroup={this.state.selectedPartGroup}
                                productList={this.state.productSeries}
                                onDelete={this.handleDelete}
                                onUpdate={this.handleAsideUpdate}
                                onTextChange={this.handleAsideTextChange}
                                isAddNew={this.state.addNew}
                                factoryDescription={this.state.factoryDescription}
                                onCancel={this.handleCancel}
                                OnAddNew={this.handleAddNewConfirm}
                                changeTextNewPartNum={this.changeTextNewPartNum}
                                newPartNumText={this.state.newPartNumText}
                                newPartDescext={this.state.newPartDescext}
                                handleaddNewPartNumToGroup={this.handleaddNewPartNumToGroup}
                                isOpen={this.state.isOpen}
                                handleOpenAddNewSection={this.handleOpenAddNewSection}
                                handleCloseAddNewSection={this.handleCloseAddNewSection}

                            />
                        )}
                    </aside>
                    <ConfirmationModal
                        body={<div className="confirmation-messages">{this.state.confirmMessage}</div>}
                        header={this.state.confirmTitle}
                        isOpen={this.state.confirmIsOpen}
                        onCancel={this.handleConfirmClose.bind( this.props )}
                        onConfirm={this.handleConfirm.bind( this.props )}
                        onHide={this.handleConfirmClose.bind( this.props )}
                    />
                </div>
                <PartGroupMultipleEntryPopup
                    isOpen={this.state.modelIsOpen}
                    onClose={this.onUploadReportClose.bind( this.props )}
                />
            </section>
        );

    }

}
PartGroupMaintenance.displayName = 'PartGroupMaintenance';
PartGroupMaintenance.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
    factoryCode: PropTypes.string.isRequired,
    factories: PropTypes.array.isRequired,
    reload: PropTypes.string.isRequired,
    updateReload: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );

export default connect( mapStateToProps, mapDispatchToProps )( PartGroupMaintenance );
